/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m12.75.75-.0121-.1348A.7502.7502 0 0 0 11.25.7486c0-.0005 0 .0004 0 0v20.3801l-9.219-9.219-.1045-.0875a.75.75 0 0 0-.9578 1.1464L12 24l11.0303-11.0303.0868-.1039a.7502.7502 0 0 0-.0868-.9568l-.1038-.0868a.7503.7503 0 0 0-.9558.0858c.0003-.0004-.0003.0003 0 0L12.75 21.1288V.75Z"
    clipRule="evenodd"
  />,
  'Connect'
);
